<div class="w-screen h-screen flex flex-col">
  @if (!this.onErrorPage) {
    <navigation-header class="z-40"/>
  }

  <div class="flex-1 flex items-stretch h-full overflow-y-auto pt-[80px] md:pt-0">
    @if (!this.onErrorPage) {
      <informations-band class="bg-noir-1 fg-blanc bb-qdm hidden xl:flex flex-col" />
    }
    <router-outlet></router-outlet>
  </div>
</div>


@if (this.needToShowCookies) {
  <div class="fixed w-full min-h-16 h-fit m-0 bg-bleu-1 right-0 bottom-0 left-0 z-50 text-white overflow-hidden flex items-center justify-between px-4 py-2">
    <p class="text-sm font-medium">
      Nous utilisons uniquement des cookies nécessaires au bon fonctionnement de l'application. Aucun suivi ou publicité.
    </p>
    <button class="border-2 hover:bg-white hover:text-black transition border-gris-3 text-bleu-1 px-4 py-2 rounded-lg text-sm font-medium" (click)="this.complyWithCookies()">
      J'ai compris
    </button>
  </div>
}
